/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MixedCheckoutForm_team = {
    readonly teamName: string;
    readonly teamId: string;
    readonly teamMembers: ReadonlyArray<{
        readonly person: {
            readonly personId: string;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
            } | null;
        };
    }>;
    readonly invitedMembers: ReadonlyArray<{
        readonly person: {
            readonly personId: string;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
            } | null;
        };
    }>;
    readonly " $fragmentRefs": FragmentRefs<"PaymentConfirmation_team">;
    readonly " $refType": "MixedCheckoutForm_team";
};
export type MixedCheckoutForm_team$data = MixedCheckoutForm_team;
export type MixedCheckoutForm_team$key = {
    readonly " $data"?: MixedCheckoutForm_team$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"MixedCheckoutForm_team">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "MixedCheckoutForm_team",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMembers",
                "plural": true,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "invitedMembers",
                "plural": true,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PaymentConfirmation_team"
            }
        ],
        "type": "Team",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'c35ad2f0540059356acf435385cfc7aa';
export default node;
